import { useTranslation } from 'react-i18next';

import Button from '../../components/Button';
import styles from './FAQ.module.scss';

interface FAQNoSearchResultsProps {
  onReset: () => void;
}

export const FAQNoSearchResults = ({ onReset }: FAQNoSearchResultsProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.noSearchResults}>
      <h2>{t('faq:noSearchResultsTitle')}</h2>
      <p>{t('faq:noSearchResultsDescription')}</p>
      <Button onClick={onReset} text={t('faq:noSearchResultsViewAllButton')} variant="contained" />
    </section>
  );
};

export default FAQNoSearchResults;
